import _ from 'underscore';
import { DEFAULT_CONFIG as DEFAULT_GRID_CONFIG } from '../ads-studio-tile-grid';

export const FOLDER_GRID_CONFIG = { ...DEFAULT_GRID_CONFIG, aspectRatio: undefined, rowHeight: 100 };

// null means loading
export const isSectionDataLoadingStatus =
  sectionData => _.every(sectionData, ({ items }) => items == null);

// [] means loaded, but no data
export const isSectionDataEmptyStatus =
  (sectionData) => {
    const anySectionLoaded = _.any(sectionData, ({ items }) => !!items);

    return anySectionLoaded && _.every(sectionData, ({ items }) => _.isEmpty(items));
  };
